import React from 'react';

import EventListTable from '../features/EventListTable';
import Body from '../typography/Body';

import StickersheetRow from './StickersheetRow';

const styleTitle = {
  marginBottom: 16,
  textTransform: 'capitalize',
};

const dateData = {
  date: 'Friday 7/13/2018',
  time: '8:00 PM',
  epochSeconds: 1,
};

const data = [
  {
    id: '2759692',
    name: 'New York Rangers vs New Jersey Devils',
    diplayVenue: 'Madison Square Garden, NY',
    dateTime: dateData,
  },
  {
    id: '3454913',
    name: 'Disney\'s Aladdin',
    diplayVenue: 'Prince Edward Theatre, GL',
    dateTime: dateData,
  },
];

export default () => (
  <StickersheetRow title="Tables">
    <Body style={styleTitle}>Event List Table</Body>
    <EventListTable
      data={data}
    />
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/Tables.js